import { render, staticRenderFns } from "./CruiseTag.vue?vue&type=template&id=55e9215b&scoped=true"
import script from "./CruiseTag.vue?vue&type=script&lang=js"
export * from "./CruiseTag.vue?vue&type=script&lang=js"
import style0 from "./CruiseTag.vue?vue&type=style&index=0&id=55e9215b&prod&lang=less&scoped=true"
import style1 from "./CruiseTag.vue?vue&type=style&index=1&id=55e9215b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e9215b",
  null
  
)

export default component.exports